import dayjs from 'dayjs';
import { partition } from 'lodash';
import { FormFields } from '~/components/ClientModal/types/form-fields.types';
import {
    ICustomFieldSchema,
    TFieldManagementTypes,
    ICustomFieldOption
} from '~/components/CustomFields/custom-field-schemas.types';

export const getCustomContactFieldId = (id: string) => {
    return `${FormFields.CUSTOM_CONTACT_FIELDS}.${id}`;
};

export const getCustomFieldId = (id: string) => {
    return `custom_fields.${id}`;
};

export type LabeledItem = {
    label: string;
    id: string;
    linked_id: string;
    options?: ICustomFieldOption[];
    fieldType?: TFieldManagementTypes;
};

export const doesFieldSchemaExist = (
    schemas: ICustomFieldSchema[],
    field: ICustomFieldSchema
) => {
    return schemas.some(
        f =>
            f.name === field.name &&
            f.type === field.type &&
            f._id !== field._id
    );
};

export const convertCustomFieldsForServer = (
    customFields: Record<string, any>
) => {
    const updatedFields = [];
    if (!!customFields) {
        Object.keys(customFields).forEach(key => {
            if (customFields[key] instanceof Date) {
                updatedFields.push({
                    linked_id: key,
                    value: dayjs(customFields[key]).format('YYYY-MM-DD')
                });
            } else if (
                customFields[key] instanceof Array &&
                customFields[key].every(item => item instanceof Object)
            ) {
                updatedFields.push({
                    linked_id: key,
                    value: customFields[key].map(({ value }) => value)
                });
            } else {
                updatedFields.push({
                    linked_id: key,
                    value: customFields[key]
                });
            }
        });
    }
    return updatedFields;
};

export const partitionFieldsByVisibility = <T extends ICustomFieldSchema>(
    fields: T[]
) => {
    return partition(
        fields,
        customFieldSchema => customFieldSchema.visible_to_clients
    );
};

export const getCustomFieldsLabels = (
    customContactFields: ICustomFieldSchema[]
): LabeledItem[] => {
    return (
        customContactFields?.map(field => {
            return {
                label: field.name,
                id: `custom_fields.${field._id}`,
                linked_id: field._id,
                options: field.options,
                fieldType: field.type
            };
        }) || []
    );
};
